/* 0.42.66 - What a page can learn about the flow it is running in.
 *
 * Null when the page is opened on its own, which is the ordinary case:
 * an element that wants flow information must cope with not being in
 * one, because the same page can be both.
 */

import { createContext, useContext } from 'react';

export const FlowContext = createContext(null);

export function useFlow() {
  return useContext(FlowContext);
}
